import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

console.log('main.tsx loaded');

const rootElement = document.getElementById('root');

if (!rootElement) {
  document.body.innerHTML = '<div style="color: white; padding: 20px; font-size: 20px;">Error: Could not find root element</div>';
  throw new Error('Failed to find the root element');
}

console.log('Root element found, creating React root...');

try {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  console.log('React app rendered successfully');
} catch (error) {
  console.error('Error rendering React app:', error);
  document.body.innerHTML = `<div style="color: white; padding: 20px;">
    <h1>Error loading application</h1>
    <pre>${error}</pre>
  </div>`;
}
